import { actions } from '../../utils/constants';

export const fetchSomeTccs = (filter) => ({
    type: actions.ASYNC_FETCH_SOME_TCCS,
    payload: filter,
});

export const fetchAllTccs = (filter) => ({
    type: actions.ASYNC_FETCH_ALL_TCCS,
    payload: filter,
});

export const updateTCC = (tcc) => ({
    type: actions.ASYNC_UPDATE_TCC,
    payload: tcc,
});

export const downloadTCC = (userId, classId, tccId, fileName = 'tcc-parcial') => ({
    type: actions.ASYNC_DOWNLOAD_TCC,
    payload: { userId, classId, tccId, fileName },
});



// WEBPACK FOOTER //
// ./src/components/tccs/tcc.actions.js